<template>
    <div class="appointments-header container mx-auto text-center md:text-left mb-4">
        <div class="w-full xl:w-3/5 float-left xl:pr-10">
            <h1 class="page-title">{{ pageTitle }}</h1>
            <p class="pb-6 text-xl text-gray-darker" v-html="copy"></p>
            <div class="info-items md:float-left text-left">
                <div v-for="(item, index) in items" :key="index" class="pb-6">
                    <img :src="getIconUrl(item.icon)" alt="" class="float-left pt-2" />
                    <p v-html="item.text" class="pl-8 text-gray-darker text-base"></p>
                </div>
            </div>
        </div>

        <div class="xl:block xl:w-2/5 md:w-4/5 float-right xl:pl-10">
            <div class="cta bg-white py-5 px-10 text-center">
                <h2 class="page-title pb-2">
                    <span>{{ priceHeader }}</span>
                    <template v-if="loadingPrices">
                        <div class="bg-gray-200">
                            <div class="skeleton-price bg-gray-300 h-12 w-1/2 mx-auto rounded-lg"></div>
                        </div>
                    </template>
                    <template v-else>
                        {{ price }}
                    </template>
                </h2>
                <p class="text-blue"><em>{{ rateText }}</em></p>
            </div>
        </div>
    </div>
</template>

<script>
    import { Prices } from "@/lib/Prices";
    import store from "@/store";
    import {formatPrice} from "@/lib/Format";

    export default {
        name: 'video-appointments-header',
        props: ['pageTitle', 'priceType', 'copy', 'items', 'switchBlockLink', 'switchBlockLabel', 'switchBlockTitle', 'switchBlockContent'],

        computed: {
          price() {
            if (this.priceType === 'virtual') {
              return formatPrice(Prices.video());
            }

            const outsideM25 = Prices.outsideM25();
            const insideM25 = Prices.insideM25();
            const centralLondon = Prices.centralLondon();

            const prices = [outsideM25, insideM25, centralLondon]
                .filter(p => p != null);

            if (prices.length === 0) return ''; // No prices available

            const minPrice = Math.min(...prices);
            return formatPrice(minPrice);
          },
          loadingPrices() {
                return store.getters['rates/getLoadingPrices']
            },
            priceHeader() {
                if (this.priceType === 'virtual') {
                  return 'Pay as you go price';
                }
                if (store.getters['rates/getLoadingPrices']) return '';

                const outsideM25 = Prices.outsideM25();
                const insideM25 = Prices.insideM25();
                const centralLondon = Prices.centralLondon();

                const prices = [outsideM25, insideM25, centralLondon].filter(p => p != null);
                if (prices.length === 1) return 'National rate of';

                const allSame = prices.every(p => p === prices[0]);
                if (allSame) return 'National rate of';

                return 'From';
            },

          partnerName() {
                return process.env.VUE_APP_PARTNER_NAME;
            },
            rateText() {
              return process.env.VUE_APP_RATE_TEXT;
            }
        },
        methods: {
            getIconUrl(icon) {
                const images = require.context('../../assets/images/', false, /\.svg$/);
                return images('./' + icon + ".svg");
            }
        }
    }
</script>

<style lang="scss" scoped>
    .skeleton-price {
        height: 48px;
    }

    .appointments-header {
        @apply px-4 mx-auto w-full;
    }

    .price-card {
        background: white;
        border-radius: 10px;
    }

    .info-items {
        @media (min-width: 768px) {
            max-width: 48%;
        }
    }

    .cta {
        border-radius: 10px;

        h2 {
            font-size:  3rem;
            line-height: 1;

          span {
            display: block;
            font-size: 1.5rem;
            line-height: 1.5rem;
          }
        }

        p {
            font-size: 14px;
            line-height: 24px;
        }

        a {
            max-width: 300px;
        }
    }
</style>